
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.838 18.188h10.824a2.1 2.1 0 002.088-2.11V5.11A2.1 2.1 0 0018.662 3H7.838A2.1 2.1 0 005.75 5.11v13.78A2.1 2.1 0 007.838 21h10.824a2.1 2.1 0 002.088-2.11 3.432 3.432 0 01-2.088.704H7.838a.702.702 0 01-.696-.703c0-.387.313-.703.696-.703zm2.784-13.782h2.089V8.89l-1.045-.791-1.044.79V4.407zm-3.48.703c0-.386.313-.703.696-.703H9.23v7.295l2.436-1.846 2.437 1.846V4.406h4.559c.383 0 .696.317.696.703v10.97a.702.702 0 01-.696.702H7.838c-.243 0-.477.042-.696.12V5.109z"}})])
          )
        }
      }
    